import { render } from "./getConsult.vue?vue&type=template&id=f54bc29c&scoped=true"
import script from "./getConsult.vue?vue&type=script&lang=js"
export * from "./getConsult.vue?vue&type=script&lang=js"

import "./getConsult.vue?vue&type=style&index=0&id=f54bc29c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f54bc29c"]])

export default __exports__